import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import AffirmMessageA from 'components/AffirmMessage/AffirmMessageA';

const AffirmContainer = (props) => {
  const { price } = props;

  useEffect(() => {
    const refreshAffirm = () => {
      if (typeof window !== 'undefined') {
        return window.affirm && window.affirm.ui.ready(() => window.affirm.ui.refresh());
      }
      return true;
    };

    if (price) {
      refreshAffirm();
    }
  }, [price]);

  return <AffirmMessageA {...props} />;
};

AffirmContainer.propTypes = {
  price: PropTypes.number,
};

export default AffirmContainer;
